import { Megaphone, Search, Magnet, MoveRight, MoveDown } from "lucide-react";
import { Reveal } from "./Reveal";

const PILLARS = [
  {
    id: "meta-ads",
    icon: Megaphone,
    title: "Meta Ads",
    copy: "Reach your ideal customers where they're already spending their time.",
    tag: "Facebook + Instagram",
  },
  {
    id: "google-ads",
    icon: Search,
    title: "Google Ads",
    copy: "Get your business in front of people actively searching for what you sell.",
    tag: "People Already Searching For You",
  },
  {
    id: "lead-generation",
    icon: Magnet,
    title: "Lead Generation",
    copy: "Turn that traffic into calls, forms, appointments and customers.",
    tag: "More Opportunities To Sell",
  },
];

export const Statement = () => (
  <section className="relative border-y border-white/5 bg-[#07070C] py-12 sm:py-16">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <h2 className="max-w-5xl font-display text-4xl font-extrabold leading-[0.95] tracking-tighter text-white sm:text-5xl lg:text-6xl">
          We Don't Sell "Marketing."{" "}
          <span className="mt-1 block text-purple-500">We Help You Get Customers.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg">
          Our job isn't likes or followers. It's simple: help put new
          customers in front of your business, every week.
        </p>
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-[1fr_auto_1fr_auto_1fr] lg:items-stretch">
        {PILLARS.map((p, i) => (
          <div key={p.id} className="contents">
            <Reveal delay={0.08 * i} className="h-full">
              <div
                data-testid={`pillar-${p.id}`}
                className="group flex h-full flex-col rounded-2xl border border-[#272732] bg-[#121217] p-8 transition-all duration-300 hover:-translate-y-1 hover:border-purple-500/50"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-purple-400 transition-colors duration-300 group-hover:bg-purple-600 group-hover:text-white">
                  <p.icon className="h-6 w-6" />
                </div>
                <h3 className="mt-6 font-display text-2xl font-extrabold uppercase tracking-tight text-white sm:text-3xl">
                  {p.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-zinc-400 md:text-base">{p.copy}</p>
                <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.2em] text-purple-400">{p.tag}</p>
              </div>
            </Reveal>
            {i < PILLARS.length - 1 && (
              <Reveal delay={0.08 * i + 0.1} className="flex items-center justify-center py-1 lg:py-0">
                <MoveRight className="hidden h-7 w-7 text-purple-500 lg:block" />
                <MoveDown className="h-7 w-7 text-purple-500 lg:hidden" />
              </Reveal>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);
